module.exports = __webpack_public_path__ + "img/pile2.475873a9.png";